<template>
  <section class="bg-white">
    <div class="menu-header">
      <div class="header-top">
        <div class="header-left">
          <Tag type="primary"
               outline
               size="small"
               class="mr-2 menu-header-tag"
               v-if="categoryTag">
            {{ categoryTag }}
          </Tag>
          <div class="menu-id" v-if="menuInformation && menuInformation.menuNo">
            メニューNo. {{ menuInformation.menuNo }}
          </div>
        </div>
        <div class="header-right">
          <Share />
        </div>
      </div>
      <h2 class="menu-title" v-if="bindData && bindData.menuInformation">
        {{ bindData.menuInformation.menuNm | capitalize }}
      </h2>
      <div class="header-meta">
        <div class="meta-item inline-flex mr-2" v-if="getAreaName">
          <i class="icon icon-bor-pin pt-1 pr-2" />
          <span>
            {{getAreaName}}
          </span>
        </div>
        <button class="c-btn btn-white btn-sm" @click="gotoMap" v-if="hasCoordinates">
          地図を見る
        </button>
      </div>
    </div>
  </section>
</template>

<script>

import _ from 'lodash'

export default {
  name: 'PlanDetailHeader',
  components: {
  },
  props: ['value'],
  data() {
    return {
      idFavorite: '',
      showPopup: false,
      inWishList: false,
      bindData: null,
      planIcons: null,
      menuInformation: null,
      statusFavorite: false
    }
  },
  created() {
    if (this.value) {
      this.bindData = this.value
      this.setData()
    }
  },
  mounted() {
  },
  watch: {
    value(val) {
      this.bindData = val
      this.setData()
    }
  },
  methods: {
    setData() {
      if (this.bindData) {
        this.menuInformation = this.bindData.menuInformation
        this.planIcons = this.bindData.planIcons
      }
    },
    gotoMap() {
      const { latitude, longitude } = _.get(this.menuInformation, 'areaInfomation', {})
      if (latitude && longitude) {
        window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
      }
    },
    copyContent() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('Copied')
    },
    copyError() {
      this.$toasted.error('Copy failed')
    }
  },
  computed: {
    hasCoordinates() {
      return _.get(this.menuInformation, 'areaInfomation.latitude', null) && _.get(this.menuInformation, 'areaInfomation.longitude', null)
    },
    getAreaName() {
      // areaMidClassNm > areaDtlClassNm
      if (this.menuInformation && this.menuInformation.areaInfomation) {
        const areaMidClassNm = this.menuInformation.areaInfomation.areaMidClassNm
        const areaDtlClassNm = this.menuInformation.areaInfomation.areaDtlClassNm
        return `${areaMidClassNm ? `${areaMidClassNm}` : ''}${areaMidClassNm && areaDtlClassNm ? ' > ' : ''}${areaDtlClassNm ? `${areaDtlClassNm}` : ''}`
      }
      return ''
    },
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    },
    categoryTag() {
      let categoryNm = ''
      if (_.get(this.menuInformation, 'categoryInfomation.catLrgClassNm')) {
        categoryNm += _.get(this.menuInformation, 'categoryInfomation.catLrgClassNm')
      }
      if (_.get(this.menuInformation, 'categoryInfomation.catMidClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.menuInformation, 'categoryInfomation.catMidClassNm')
      }
      if (_.get(this.menuInformation, 'categoryInfomation.catSmlClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.menuInformation, 'categoryInfomation.catSmlClassNm')
      }
      return categoryNm
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
